export function storageFactory(storage) {
	let inMemoryStorage = {};

	function isSupported() {
		try {
			const testKey = "__localstoragetestkey__";
			storage.setItem(testKey, testKey);
			storage.removeItem(testKey);
			return true;
		} catch (e) {
			return false;
		}
	}

	function clear() {
		if (isSupported()) {
			storage.clear();
		} else {
			inMemoryStorage = {};
		}
	}

	function getItem(name) {
		if (isSupported()) {
			return storage.getItem(name);
		}
		if (inMemoryStorage.hasOwnProperty(name)) {
			return inMemoryStorage[name];
		}
		return null;
	}

	function key(index) {
		if (isSupported()) {
			return storage.key(index);
		} 
		else {
			return Object.keys(inMemoryStorage)[index] || null;
		}
	}

	function removeItem(name) {
		if (isSupported()) {
			storage.removeItem(name);
		} 
		else {
			delete inMemoryStorage[name];
		}
	}

	function setItem(name, value) {
		if (isSupported()) {
			storage.setItem(name, value);
		} 
		else {
			inMemoryStorage[name] = String(value); // not everyone uses TypeScript
		}
	}

	function length() {
		if (isSupported()) {
			return storage.length;
		} 
		else {
			return Object.keys(inMemoryStorage).length;
		}
	}

	return {
		getItem,
		setItem,
		removeItem,
		clear,
		key,
		get length() {
			return length();
		},
	};
}